import HomeView from "@/views/home/index.vue";
export default [
  {
    path: "/",
    name: "Home",
    component: HomeView,
    meta: {
      isLogin: false,
      title: "首页",
    },
  },
  {
    path: "/cable-mall",
    name: "CableMall",
    meta: {
      isLogin: false,
      title: "易缆商城",
      broadHead: 2,
    },
    component: () => import("@/views/cableMall/index.vue"),
  },
  {
    path: "/enterprise/home",
    name: "certificationHome",
    meta: {
      isLogin: false,
      title: "易缆原料",
      broadHead: 1,
    },
    component: () => import("@/views/cableMall/index.vue"),
  },
  {
    path: "/other-mall",
    name: "OtherMall",
    meta: {
      isLogin: false,
      title: "其它",
      broadHead: 3,
    },
    component: () => import("@/views/cableMall/index.vue"),
  },
  {
    path: "/order/preview",
    name: "Preview",
    meta: {
      title: "订单预览",
    },
    component: () => import("@/views/order/Preview.vue"),
  },
  {
    path: "/search-results",
    name: "SearchResults",
    meta: {
      isLogin: false,
      title: "搜索页",
      isShowHeader: true,
    },
    component: () => import("@/views/SearchResults/index.vue"),
  },
  {
    path: "/cable-finance",
    name: "CableFinance",
    meta: {
      isLogin: false,
      title: "易缆金融",
    },
    component: () => import("@/views/cableFinance/home/index.vue"),
  },
  {
    path: "/cable-Ai",
    name: "cableAi",
    meta: {
      isLogin: false,
      title: "易缆AI",
    },
    component: () => import("@/views/cableAi/index.vue"),
  },
  {
    path: "/cable-ai/agents",
    name: "Agents",
    meta: {
      isLogin: false,
      title: "易缆AI-智能体广场",
    },
    component: () => import("@/views/cableAi/agents.vue"),
  },
  {
    path: "/cable-ai/models",
    name: "Models",
    meta: {
      isLogin: false,
      title: "易缆AI-词元广场",
    },
    component: () => import("@/views/cableAi/models.vue"),
  },
  {
    path: "/cable-ai/skillMall",
    name: "SkillMall",
    meta: {
      isLogin: false,
      title: "易缆AI-技能广场",
    },
    component: () => import("@/views/cableAi/skillMall.vue"),
  },
  {
    path: "/cable-ai/demandHall",
    name: "DemandHall",
    meta: {
      isLogin: false,
      title: "易缆AI-需求大厅",
    },
    component: () => import("@/views/cableAi/demandHall.vue"),
  },
  {
    path: "/cable-ai/ai-capability",
    name: "Datasets",
    meta: {
      isLogin: false,
      title: "易缆AI-供给大厅",
    },
    component: () => import("@/views/cableAi/ai-capability.vue"),
  },
  {
    path: "/cable-ai/datasets",
    name: "Datasets",
    meta: {
      isLogin: false,
      title: "易缆AI-数据集专区",
    },
    component: () => import("@/views/cableAi/datasets.vue"),
  },
  {
    path: "/purchase",
    name: "Purchase",
    meta: {
      isLogin: false,
      title: "易缆物联",
    },
    component: () => import("@/views/purchase/index.vue"),
  },
  {
    path: "/storage",
    name: "Storage",
    meta: {
      isLogin: false,
      title: "易缆云仓",
    },
    component: () => import("@/views/storage/index.vue"),
  },
  {
    path: "/storage/shop",
    name: "StorageShop",
    meta: {
      isLogin: false,
      title: "易缆云仓",
    },
    component: () => import("@/views/storage/shop.vue"),
  },
  {
    path: "/cable-finance/products",
    name: "CableFinanceProducts",
    meta: {
      isLogin: false,
      title: "产品中心",
    },
    component: () => import("@/views/cableFinance/product/index.vue"),
    children: [
      {
        path: "/cable-finance/products/:id",
        name: "CableFinanceProductsDetail",
        meta: {
          keepAlive: true,
          isLogin: false,
          title: "产品详情",
        },
        component: () => import("@/views/cableFinance/product/list/index.vue"),
      }
    ]
  },
  {
    path: "/cable-finance/apply/:type",
    name: "financeApply",
    meta: {
      isLogin: true,
    },
    component: () => import("@/views/cableFinance/apply/index.vue"),
  },
  // 金融产品详情页
  {
    path: "/cable-finance/product/:id",
    name: "financeProduct",
    meta: {
      isLogin: false,
      title: "金融产品详情",
    },
    component: () => import("@/views/cableFinance/product/detail/index.vue"),
  },
  // 深度页面
  {
    path: '/cable-finance/sd',
    name: 'CableFinanceSd',
    meta: {
      isLogin: false,
      title: '深度'
    },
    component: () => import('@/views/cableFinance/sdopen/index.vue')
  },
  // 商票直融
  {
    path: "/cable-finance/ticket/commercial",
    name: "financeTicketCommercial",
    meta: {
      isLogin: false,
    },
    component: () => import("@/views/cableFinance/ticket/index.vue"),
  },
  // 银票秒贴
  {
    path: "/cable-finance/ticket/discount",
    name: "financeTicketDiscount",
    meta: {
      isLogin: false,
    },
    component: () => import("@/views/cableFinance/ticket/index.vue"),
  },
  {
    path: "/cable-logistics",
    name: "CableLogistics",
    meta: {
      isLogin: false,
      title: "易缆物流",
    },
    component: () => import("@/views/cableLogistics/index.vue"),
  },
  {
    path: "/articleList",
    name: "articleList",
    meta: {
      isLogin: false,
      title: "易缆资讯",
      keepAlive: true,
    },
    component: () => import("@/views/officialWebsite/ArticleList.vue"),
  },
  {
    path: "/articlePage/:id",
    name: "ArticlePage",
    meta: {
      isLogin: false,
    },
    component: () => import("@/views/officialWebsite/ArticlePage.vue"),
  },
  {
    path: "/companyList",
    name: "companyList",
    meta: {
      isLogin: false,
      title: "易缆入驻",
      keepAlive: true,
    },
    component: () => import("@/views/officialWebsite/CompanyList.vue"),
  },
  {
    path: "/enterprisePage/:id",
    name: "EnterprisePage",
    redirect: "/enterprisePage/:id/1",
    meta: {
      isLogin: false,
    },
    component: () => import("@/views/officialWebsite/empty.vue"),
    children: [
      {
        path: ":show",
        name: "EnterprisePageShow",
        component: () => import("@/views/officialWebsite/EnterprisePage.vue"),
      },
    ],
    // component: () => import('@/views/officialWebsite/EnterprisePage.vue')
  },
  // {
  //   path: '/mbHome',
  //   name: 'MbHome',
  //   meta:{
  //     isShowHeader: true,
  //     isLogin: false
  //   },
  //   component: () => import('@/views/mbHome/index.vue')
  // }
  {
    path: "/internation",
    name: "Internation",
    meta: {
      isShowHeader: true,
      isLogin: false,
    },
    component: () => import("@/views/international/index.vue"),
  },
  {
    path: "/liveStream",
    name: "LiveStream",
    meta: {
      isLogin: false,
      title: "易缆直播",
      keepAlive: true,
    },
    component: () => import("@/views/cableLiveStream/index.vue"),
  },
];
